import PropTypes from 'prop-types';
import merge from 'lodash/merge';
import ReactApexChart from 'react-apexcharts';
// @mui
import { useTheme, styled } from '@mui/material/styles';
import { Card, CardHeader } from '@mui/material';
// utils
import { fNumber } from '../../../utils/formatNumber';
// components
import { BaseOptionChart } from '../../../components/chart';

// ----------------------------------------------------------------------

const CHART_HEIGHT = 372;
const LEGEND_HEIGHT = 72;

const ChartWrapperStyle = styled('div')(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(5),
  '& .apexcharts-canvas svg': { height: CHART_HEIGHT },
  '& .apexcharts-canvas svg,.apexcharts-canvas foreignObject': {
    overflow: 'visible',
  },
  '& .apexcharts-legend': {
    height: LEGEND_HEIGHT,
    alignContent: 'center',
    position: 'relative !important',
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`,
  },
}));

// ----------------------------------------------------------------------

AppDonutChart.propTypes = {
    title: PropTypes.string,
    subheader: PropTypes.string,
    chartColors: PropTypes.arrayOf(PropTypes.string),
    chartData: PropTypes.array.isRequired,
  };
  
  export default function AppDonutChart({ title, subheader, chartData, chartColors, ...other }) {
    const theme = useTheme();
  
    const chartLabels = chartData.map((i) => i.label);
    const chartSeries = chartData.map((i) => i.value);
  
    const chartOptions = merge(BaseOptionChart(), {
      colors: chartColors,
      labels: chartLabels,
      stroke: { colors: [theme.palette.background.paper] },
      legend: { floating: true, horizontalAlign: 'center' },
      dataLabels: { enabled: true },
      tooltip: {
        y: {
          formatter: (val) => val.toLocaleString(),
        },
      },
      plotOptions: {
        pie: {
          donut: { labels: { show: true } },
        },
      },
    });
  
    return (
      <Card {...other}>
        <CardHeader title={title} subheader={subheader} />
        <ChartWrapperStyle dir="ltr">
          <ReactApexChart type="donut" series={chartSeries} options={chartOptions} height={280} />
        </ChartWrapperStyle>
      </Card>
    );
  }